import { selectRoleAsyncResponse } from "./types";
import * as roleActions from "./roles.actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiGet, API_URL_ROLE, retrieveToken } from "../../../helpers/api";

export function* selectRole(action: ReturnType<typeof roleActions.selectRoleAsync.request>) {
  try {
    const token: string = yield retrieveToken();
    const result: Response = yield call(apiGet, API_URL_ROLE.SELECT_ROLE(action.payload.id), token);
    if (result.status === 200) {
      const parsed: selectRoleAsyncResponse = yield call(result.json.bind(result));
      yield put(roleActions.selectRoleAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(roleActions.selectRoleAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(roleActions.selectRoleAsync.failure(parsed));
  }
}

export default function* rolesSagaSelectRole() {
  yield takeEvery(roleActions.selectRoleAsync.request, selectRole);
}
